import { gql } from "@apollo/client";
import { addTypePolicies } from "src/lib/graphql/cache";
import useGQLPaginatedQuery from "src/lib/graphql/hooks/useGQLPaginatedQuery";
import useGQLQuery from "src/lib/graphql/hooks/useGQLQuery";
import paginatedListFieldPolicy from "src/lib/graphql/utils/paginatedListFieldPolicy";
export const SUBJECT_NOTES_LIST_QUERY = gql `
  query EP_SubjectNotesList($subjectID: ID!, $filters: EPSubjectNoteListFilters, $pagination: PaginationOptions!) {
    ep_notesForSubject(subjectID: $subjectID, filters: $filters, pagination: $pagination) {
      totalCount
      list {
        id
        data {
          title
          topics
          slug
        }
        utime
      }
    }
  }
`;
;
export function useSubjectNotesListQuery(options) {
    return useGQLPaginatedQuery(SUBJECT_NOTES_LIST_QUERY, 'ep_notesForSubject', options);
}
/** ponytail: 50-note cap per topic banner; add fetchMore if topics grow past that. */
const TOPIC_NOTES_BANNER_LIMIT = 50;
export function useSubjectNotesForTopicQuery(subjectID, topic, options) {
    return useGQLQuery(SUBJECT_NOTES_LIST_QUERY, {
        variables: {
            subjectID,
            filters: { topics: [topic] },
            pagination: { offset: 0, limit: TOPIC_NOTES_BANNER_LIMIT },
        },
        skip: !subjectID || !topic,
        fetchPolicy: 'cache-and-network',
        ...options,
    });
}
addTypePolicies({
    Query: {
        fields: {
            ep_notesForSubject: paginatedListFieldPolicy(['subjectID', 'filters']),
        },
    },
});
